module.exports = __webpack_public_path__ + "img/0Q3A8493_FoamcoreMatted.15b7bd1a.jpg";